module.exports = __webpack_public_path__ + "img/5.89a7538a.jpg";